import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./vue-ocom/auth/store";
import AxiosAuthPlugin from "./vue-ocom/auth/store/plugin";
import AppModules from "./app/store";
import UsersAppModules from "./vue-ocom/grouppermissions/store";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const allModules = Object.assign(
  {
    AuthModule,
  },
  AppModules,
  UsersAppModules
);

export default new Vuex.Store({
  plugins: [AxiosAuthPlugin],
  modules: allModules,
  strict: debug,
  state: {
    messages: {
      show: false,
    },
  },
  mutations: {
    showMessage(state, messages) {
      console.log(messages);

      state.messages = messages;
    },
  },
  actions: {},
  getters: {
    messages(state) {
      return state.messages || { show: false };
    },
  },
});
